export class ImportreturnBO {
    id: string;
    importedDate: string;
    senderId: string;
    fileName: string;
    senderIdQualifier: string;
    receiverId: string;
    receiverIdQualifier: string;
}

export class ImportBO {
    filepath: string;
    // attachments: FormFile;
}

export class returnimport835 {
    invoice: Invoice835BO;
    error: string;
}

export class Invoice835BO {
    payorDetail: PayorDetail;
    paymentDetail: PaymentDetail;
    patient_ClaimDetail: Patient_ClaimDetail[];
}

export class PayorDetail {
    payorName: string;
    payorStreet: string;
    payorCity: string;
    payorState: string;
    payorZiPCode: string;
    payorId: string;
}

export class PaymentDetail {
    companyName: string;
    payment_Method: string;
    provider: string;
    chk_EFT_date: string;
    date: string;
    remittance_Amount: number;
    check_EFT_NBR: string;
}

export class Patient_ClaimDetail {
    patient: string;
    hIC: string;
    patCtrl: string;
    payor_Claim_Number: string;
    totalUnit: number;
    totalBilledAmt: number;
    totalClaimAmt: number;
    serviceLineDetail: ServiceLineDetail[];
    companydetails: companydetails[];
}


export class companydetails {
    companyAddress: string;
    companyCity: string;
    companyName: string;
}
export class ServiceLineDetail {
    serviceDate: string;
    unit: number;
    servicecode: string;
    mOD: string;
    billedAmt: number;
    denied_Detail: string;
    claimed_Amt: number;
    notes: string;
}
export class EDI835BO {
    importedDate: string;
    senderId: string;
    senderIdQualifier: string;
    receiverId: string;
    receiverIdQualifier: string;
    interchangeControlNumber: string;
    eDI835Transactions: EDI835TransactionBO[];
}
export class EDI835TransactionBO {
    eDI835Payers: EDI835PayerBO;
    eDI835Payees: EDIPayeeBO;
    eDI835Payments: EDI835PaymentBO;
    dTM: DTMBO;
    tRN: TRNBO;
    eDI835Claims: EDI835ClaimBO[];
    eDI835PayorContactDetails: EDI835PayorContactDetailsBO[];
}
export class DTMBO {
    dTM_ProductionDateTimeQualifier: string;
    dTM_ProductionDate: string | null;
}

export class EDI835PayorContactDetailsBO {
    contactFunctionCode: string;
    responseContactName: string;
    communicationNumberQualifier: string;
    responseContactCommunicationNumber: string;
}
export class TRNBO {
    tRN_TraceTypeCode: string;
    tRN_TransactionTraceNumber: string;
    tRN_CompanyIdentifier: string;
    tRN_ReferenceIdentification: string;
}


export class EDI835PaymentBO {
    bPR_TransactionHandlingCode: string;
    bPR_TotalPremiumPaymentAmount: number | null;
    bPR_CreditorDebitFlagCode: string;
    bPR_PaymentMethodCode: string;
    bPR_PaymentFormatCode: string;
    bPR_SenderDFIIdQualifier: string;
    bPR_SenderDFIIdentifier: string;
    bPR_SenderAccountNumberQualifier: string;
    bPR_SenderBankAccountNumber: string;
    bPR_PayerIdentifier: string;
    bPR_CompanySupplementalCode: string;
    bPR_ReceiverDFIIdQualifier: string;
    bPR_ReceiverDFIIdentifier: string;
    bPR_ReceiverAccountNumberQualifier: string;
    bPR_ReceiverBankAccountNumber: string;
    bPR_CheckIssueorEFTEffectiveDate: string | null;
}

export class EDI835PayerBO {
    payer_EntityIdentifierCode: string;
    payer_Name: string;
    payer_IdentificationCodeQualifier: string;
    payer_IntermediaryBankIdentifier: string;
    payer_Address_1: string;
    payer_Address_2: string;
    payer_City: string;
    payer_State: string;
    payer_Zip: string;
}

export class EDIPayeeBO {
    payee_EntityIdentifierCode: string;
    payee_Name: string;
    payee_IdentificationCodeQualifier: string;
    payee_IntermediaryBankIdentifier: string;
    payee_Address_1: string;
    payee_Address_2: string;
    payee_City: string;
    payee_State: string;
    payee_Zip: string;
}

export class EDI835ClaimBO {
    cLP_PatientControlNumber: string;
    cLP_ClaimStatusCode: string;
    cLP_TotalClaimChargeAmount: number | null;
    cLP_ClaimPaymentAmount: number | null;
    cLP_PatientResponsiblityAmount: number | null;
    cLP_ClaimIndicatorCode: string;
    cLP_PayerClaimControlNumber: string;
    cLP_FacilitytypeCode: string;
    nM1_EntityIdentifierCode: string;
    nM1_EntityTypeQualifier: string;
    nM1_LastorOrganizationName: string;
    nM1_FirstName: string;
    nM1_MiddleName: string;
    nM1_NamePrefix: string;
    nM1_ResponseContactNameSuffix: string;
    nM1_IdentificationCodeQualifier: string;
    nM1_ContactIdentifier: string;
    claimStartDate: string | null;
    claimEndDate: string | null;
    receivedDate: string | null;
    eDI835ClaimServiceLine: EDI835ClaimServiceLineBO[];
    eDI835ClaimReference: EDI835ClaimReferenceBO[];
}

export class EDI835ClaimReferenceBO {
    referenceIdentificationQualifier: string;
    memberGrouporPolicyNumber: string;
    description: string;
}

export class EDI835ClaimServiceLineBO {
    productorServiceIDQualifier: string;
    serviceCode: string;
    modifier1: string;
    modifier2: string;
    modifier3: string;
    modifier4: string;
    description: string;
    lineItemChargeAmount: number | null;
    monetaryAmount: number | null;
    revenueCode: string;
    quantity: number | null;
    serviceStartDate: string | null;
    serviceEndDate: string | null;
    eDI835ClaimAdjustmentBO: EDI835ClaimAdjustmentBO[];
    eDI835ClaimServiceLineReferenceBO: EDI835ClaimServiceLineReferenceBO[];
    eDI835ServiceSupplementalAmountBO: EDI835ServiceSupplementalAmountBO[];
}

export class EDI835ClaimAdjustmentBO {
    adjustmentGroupCode: string;
    adjustmentReasonCode: string;
    adjustmentAmount: number | null;
    adjustmentQuantity: string;
}

export class EDI835ClaimServiceLineReferenceBO {
    referenceIdentificationQualifier: string;
    memberGrouporPolicyNumber: string;
    description: string;
}
export class EDI835ServiceSupplementalAmountBO {
    amountQualifierCode: string;
    totalClaimChargeAmount: number | null;
    creditDebitFlagCode: string;
}


export class GetListBO {
    orderColumn: string = "id";
    orderType: string = "desc";
    pageitem: number=10;
    currentpageno: number = 1;
    field: string = "fileName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    agencyID: number;
    type: string = "string";

}

export class functionpermission {
    importpaymentupload: boolean = true;
 

}

export class ColumnChangeBO {
    id: string="00000000-0000-0000-0000-000000000000";
    userid: string="00000000-0000-0000-0000-000000000000";
    agencyId: string="00000000-0000-0000-0000-000000000000";
    column: string;
}

export class WhereCondition {
    field: string = "listcode";
    value: string = "";
    operator: string = "startswith";
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
    matchCase: boolean = false;
}

export class searchfilterDetails {
    Filter_City: string;
    Filter_State: string;
    Filter_Zipcode: string;
}
